import { FullPageLoader } from '../components/full-page-loader/full-page-loader';
import { useRootMenu } from '../queries/ats/layout/queries';
import { Page } from '../views/ats-pages/page/page';

export function HomePage() {
  const { data: menu, isLoading } = useRootMenu();

  if (isLoading) {
    return <FullPageLoader />;
  }

  if (menu === undefined) {
    throw new Error('Root menu not found');
  }

  const rootMenu = menu.find((item) => item.isRoot) ?? menu[0];

  return <Page slug={rootMenu.slug} hideHeading />;
}
